import React from 'react';
import { Box, Typography } from '@mui/material';
import { SaveComplianceItemButton } from '../actions';
import GoBackButton from '../../../../common/components/styled-ui-elements/GoBackButton';

/**
 * ComplianceCreateHeader - Header section for compliance item creation
 * Contains title, description, and action buttons
 */
export const ComplianceCreateHeader: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography
            variant="h5"
            component="h1"
            fontWeight={600}
            color="#1e293b"
            sx={{ mb: 0.5 }}
          >
            Create Compliance Requirement
          </Typography>
          <Typography
            variant="body2"
            color="#64748b"
            sx={{ fontSize: '0.9rem' }}
          >
            Add a new compliance requirement to track
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          <SaveComplianceItemButton label="Save Compliance Item" successMessage="Compliance item created successfully!" />
          <GoBackButton />
        </Box>
      </Box>
    </Box>
  );
};

export default ComplianceCreateHeader;
